import React from 'react';
import * as PropTypes from "prop-types";
import FormBuilder from "../components/FormikBuilder";
import http from '../utils/api';
import DropButtonBuilder from '../components/FormikBuilder/DropButtonBuilder';
import InputDateBuilder from '../components/FormikBuilder/InputDateBuilder';
import InputTextBuilder from '../components/FormikBuilder/InputTextBuilder';
import InputAutoCompleteBuilder from '../components/FormikBuilder/InputAutoCompleteBuilder';
import moment from 'moment';
import localforage from '../utils/localforage';
import filterPendency from '../contexts/filterPendency';
import { getColaboradorAcessos } from '../utils/storage';
import {initSystem, initSystemLiderado} from "../provider/system.service";


function FilterPendency(props) {  

    const renderColaboradorFilter = getColaboradorAcessos().find(ca => ca => ca.codigoNivelOperacao === 'SH' || ca.codigoNivelOperacao === 'RC' )!== undefined;
    const {data, dateTime, ...other} = props;
    return (
        <FormBuilder key={'filterPendency'} initialState={filterPendency} data={data} schema={
            () => ({
                props: {
                    PaperProps: {
                        style: {
                            minHeight: 260
                        },
                    },
                },
                actions: [
                    {
                        label: 'Cancelar',
                        props: {
                            key: 'cancel',
                            type: 'button',
                            // color: 'primary',
                        }
                    },
                    {
                        label: 'limpar',
                        props: {
                            key: 'clear',
                            type: 'reset',
                            // color: 'primary',
                        },
                        onClick: e => {
                            localforage.setItem('liderado', {codigoLiderado: '', nomeLiderado: ''}).then();
                        }
                    },
                    {
                        label: 'filtrar',
                        props: {
                            key: 'submit',
                            type: 'submit',
                            variant: 'outlined',
                            // color: 'primary',
                        },

                    }
                ],
                onSubmit: (e) => {
                    e.preventDefault();
                    props.onChange(e);
                }
            })} {...other}>
            {
                (form, props) => {
                    function onChangeAutoComplete(ev, value) {
                        form.setValues({...form.values,...value} ?? {});
                    }

                    function onChangeAutoCompleteLiderado(ev, value) {
                        localforage.setItem('liderado', value).then();
                        form.setValues({...form.values,...value} ?? {});
                        initSystemLiderado();
                    }

                    function setDataFilter(days) {
                        form.setValues({
                            dataHoraInicio: moment().subtract(days, 'days'),
                            dataHoraFim: moment(),
                        });
                    }

                    async function setDataPeriodo() {
                        let periodo = await localforage.getItem('periodo');
                        form.setValues({
                            dataHoraInicio: moment(periodo.inicio),
                            dataHoraFim: moment(periodo.fim),
                        });
                    }

                    return (<>
                        <DropButtonBuilder form={form} formProps={props} fieldSchema={{
                            sizes: {
                                sm: 12,
                                lg: 3,
                            },
                            props: {
                                /*style: {
                                    position: 'absolute',
                                    bottom: 0,
                                    left: 0,
                                }*/
                            },
                            default: {
                                label: 'Hoje',
                                onClick: () => setDataFilter(0),
                            },
                            options: [
                                {
                                    label: 'Período Atual',
                                    onClick: () => setDataPeriodo(),
                                },
                                {
                                    label: '3 últimos dias',
                                    onClick: () => setDataFilter(3),
                                },
                                {
                                    label: '7 últimos dias',
                                    onClick: () => setDataFilter(7),
                                },
                                {
                                    label: '15 últimos dias',
                                    onClick: () => setDataFilter(15),
                                },
                                {
                                    label: '30 últimos dias',
                                    onClick: () => setDataFilter(30),
                                },
                            ],
                            type: 'dropButton',
                        }}/>
                        <InputDateBuilder form={form} formProps={props} fieldSchema={{
                            label: 'Data Início',
                            field: 'dataHoraInicio',
                            sizes: {
                                sm: 12,
                                lg: 3,
                            },
                            format: 'DD/MM/YY',
                            type: 'date',
                            isRequired: true,
                        }}/>
                        <InputDateBuilder form={form} formProps={props} fieldSchema={{
                            label: 'Data Fim',
                            field: 'dataHoraFim',
                            sizes: {
                                sm: 12,
                                lg: 3,
                            },
                            format: 'DD/MM/YY',
                            type: 'date',
                            isRequired: true,
                        }}/>

                        <InputTextBuilder form={form} formProps={props} fieldSchema={{
                            label: 'Pendência',
                            field: 'pendenciaId',
                            sizes: {
                                sm: 12,
                                lg: 3,
                            },
                            type: 'text'
                        }}/>

                        <InputAutoCompleteBuilder form={form} formProps={props} fieldSchema={{
                            label: 'Projeto',
                            field: 'codigoProjeto',
                            sizes: {
                                sm: 12,
                                lg: 4,
                            },
                            clear: () => {
                                form.setValues({
                                    ...form.values,
                                    codigoProjeto: null,
                                    codigoSubsistema: null,
                                });
                            },
                            getOptions: (async (setOptions) => {
                                const response = await http.get('projetos-atividade', {
                                    params: {
                                        qtdeItens: 9999
                                    }
                                });
                                let resultsArray = (response?.data?.data ?? []).map(option => {
                                    return {codigoProjeto: option.codigoProjeto}
                                });
                                setOptions(resultsArray);
                            }),
                            onChange: onChangeAutoComplete,
                            getOptionLabel: option => (option?.['codigoProjeto'] && `${option['codigoProjeto']} ${option['codigoArea'] ? `(${option['codigoArea']})` : ''}`) || '',
                            type: 'autocomplete',
                        }}/>
                        <InputAutoCompleteBuilder form={form} formProps={props} fieldSchema={{
                            label: 'Subsistema',
                            field: 'codigoSubsistema',
                            sizes: {
                                sm: 12,
                                lg: 5,
                            },
                            listen: 'codigoProjeto',
                            getOptionLabel: option => (option?.['codigoSubsistema'] && `${option['codigoSubsistema']} ${option['codigoArea'] ? `(${option['codigoArea']})` : ''}`) || '',
                            getOptions: (async (setOptions) => {
                                let resultsArray = [];
                                if (form.values?.['codigoProjeto']) {
                                    const response = await http.get(`subsistemas-alocados`, {
                                        params: {
                                            codigoProjeto: form.values?.['codigoProjeto'],
                                            qtdeItens: 9999
                                        }
                                    });
                                    resultsArray = (response?.data?.data ?? []).map(option => {
                                        return {
                                            codigoProjeto: option.codigoProjeto,
                                            codigoSubsistema: option.codigoSubsistema
                                        }
                                    });
                                    setOptions(resultsArray);
                                }

                            }),
                            onChange: onChangeAutoComplete,
                            type: 'autocomplete',
                            clear: () => {
                                form.setValues({
                                    ...form.values,
                                    codigoSubsistema: null,
                                });
                            },
                        }}/>
                        { renderColaboradorFilter ? (
                            <InputAutoCompleteBuilder form={form} formProps={props} fieldSchema={{
                                label: 'Colaborador',
                                field: 'codigoLiderado',
                                sizes: {
                                    sm: 12,
                                    lg: 12,
                                },
                                listen: 'codigoLiderado',
                                getOptionLabel: option => (option?.['nomeLiderado']) || '',
                                getOptions: (async (setOptions) => {
                                    const response = await http.get(`colaborador/liderados`, {
                                        params: {
                                        }
                                    });
                                    let resultsArray = (response?.data ?? []).map(option => {
                                        return {
                                            codigoLiderado: option.codigoColaborador, 
                                            nomeLiderado: option.nome
                                        }
                                    });
                                    setOptions(resultsArray);
                                }),
                                onChange: onChangeAutoCompleteLiderado,
                                type: 'autocomplete',
                                clear: () => {
                                    localforage.setItem('liderado', {codigoLiderado: '', nomeLiderado: ''}).then();
                                    form.setValues({
                                        ...form.values,
                                        codigoLiderado: null,
                                        nomeLiderado: null,
                                    });
                                    initSystem();
                                },
                            }}/>
                        ) : (
                            <></>
                        )}
                    </>)
                }
            }
        </FormBuilder>);
}


FilterPendency.propTypes = {
    data: PropTypes.object,
    onSubmit: PropTypes.func,
    onCancel: PropTypes.func,
};

FilterPendency.defaultProps = {
    data: {}
};

export default FilterPendency;
